import Dashboard from './views/dashboard/Dashboard.js';
import Profile from './views/dashboard/Profile.js';
import Chargers from './views/dashboard/Chargers.js';
import Signup from './views/auth/Signup.js';
import Login from './views/auth/Login.js';
import EarningList from 'views/dashboard/Earning.js';
import { BsBatteryCharging } from 'react-icons/bs';
import ChargingSessions from 'views/dashboard/ChargingSessions.js';
import CorporateChargingSessions from 'views/Corporates/CorporateChargingSessions.js';
import CorporateDetails from 'views/Corporates/CorporateDetails.js';

export const routes = [
  {
    path: '/index',
    name: 'Dashboard',
    icon: 'fas fa-home',
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/chargers',
    name: 'Chargers',
    icon: 'fas fa-charging-station',
    component: Chargers,
    layout: '/admin',
  },
  {
    path: '/sessions',
    name: 'Charging Sessions',
    icon: <BsBatteryCharging />,
    component: ChargingSessions,
    layout: '/admin',
  },
  {
    path: '/analytics',
    name: 'Analytics',
    icon: 'fas fa-chart-line',
    component: EarningList,
    layout: '/admin',
  },
  {
    path: '/login',
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: Login,
    layout: '/auth',
  },
  {
    path: '/register',
    name: 'Signup',
    icon: 'ni ni-circle-08 text-pink',
    component: Signup,
    layout: '/auth',
  },
  {
    path: '/myAccount',
    name: 'My Profile',
    icon: 'fas fa-user',
    component: Profile,
    layout: '/admin',
  },
];

export const corporateAdminRoutes = [
  {
    path: '/index',
    name: 'Dashboard',
    icon: 'fas fa-home',
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/plans',
    name: 'Plans & Groups',
    icon: 'fas fa-layer-group',
    component: CorporateDetails,
    layout: '/corporate',
  },
  {
    path: '/chargers',
    name: 'Corporate Chargers',
    icon: 'fas fa-charging-station',
    component: Chargers,
    layout: '/corporate',
  },
  {
    path: '/sessions',
    name: 'Corporate Sessions',
    icon: <BsBatteryCharging />,
    component: CorporateChargingSessions,
    layout: '/corporate',
  },
  {
    path: '/users',
    name: 'Corporate Users',
    icon: 'fas fa-users',
    component: ChargingSessions,
    layout: '/corporate',
  },
  // {
  //   path: '/myAccount',
  //   name: 'My Profile',
  //   icon: 'fas fa-user',
  //   component: Profile,
  //   layout: '/admin',
  // },
];
